import Box from '@mui/material/Box';
import React, { ReactElement } from 'react';

interface ComponentProps {
  icon: ReactElement;
  commonStyle?: React.CSSProperties;
}

const Component: React.FC<ComponentProps> = ({ icon, commonStyle }) => (
  <Box sx={{ ...commonStyle }}>{icon}</Box>
);

export default Component;
